import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import logoImage from '../img/logo.png'; // Importa a imagem da logo

import { useAuthContext } from '../context/AuthContext'; // Importar o AuthContext

const Login = () => { 
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login } = useAuthContext(); // Obter a função de login do contexto
  const navigate = useNavigate(); // Hook para navegação

  const handleSubmit = async (e) => { // Renomeado para handleSubmit para consistência
    e.preventDefault();
    setError(null);
    setIsLoading(true);

try {
      const loginData = await login(email, password); // Chama a função de login do AuthContext

      // O AuthContext agora lida com o armazenamento do token e dados do usuário.
      // A navegação será tratada pelo App.js ou ProtectedRoute com base no authState.
      // Se o login for bem-sucedido e o onboarding não estiver completo, o ProtectedRoute redirecionará para /onboarding/...
      // Se o onboarding estiver completo, redirecionará para /dashboard ou a primeira aba permitida.
      if (loginData) {
        if (loginData.onboarding && !loginData.onboarding.complete) {
          // O redirecionamento para a etapa correta do onboarding será feito pelo ProtectedRoute/OnboardingGuard
          navigate(loginData.onboarding.step ? `/onboarding/${loginData.onboarding.step.replace('pending_', '')}` : '/onboarding/materials', { replace: true });
        } 
        else {
          // Redireciona para a raiz. O App.js e o ProtectedRoute cuidarão do destino final.
          navigate('/', { replace: true });
        }
      } else {
        setError('Falha ao processar o login. Tente novamente.'); // Mensagem genérica
      }
    } catch (err) { // O catch continua aqui
        if (err.response && err.response.data && err.response.data.message) {
          setError(err.response.data.message);
        } else if (err.request) {
          setError('Não foi possível conectar ao servidor. Verifique sua conexão.');
        } else {
          setError('Ocorreu um erro ao tentar fazer login. Tente novamente.');
        }
        console.error('Erro no login:', err);
      } finally { // O finally continua aqui
        setIsLoading(false);
      }
  };

  return (
    <Card style={{ width: '100%', maxWidth: '400px' }}>
      <Card.Body>
        <div className="text-center mb-4">
          <img src={logoImage} alt="Logo Clínica" style={{ maxHeight: '180px' }} className="mb-3" /> {/* Logo descomentada e usada */}
        </div>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Digite seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Senha</Form.Label>
            <Form.Control
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
            {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> : null}
            Entrar
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default Login;
